import AuthorTools from './author-tools';

export default AuthorTools;
